/**
 * @generated SignedSource<<1e4d46cf2efdadb58c3bbc687dabfaca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type NotificationsTabArchiveMutation$variables = {
  input: NodeInput;
};
export type NotificationsTabArchiveMutation$data = {
  readonly archiveNotification: {
    readonly isArchived: boolean;
  };
};
export type NotificationsTabArchiveMutation = {
  response: NotificationsTabArchiveMutation$data;
  variables: NotificationsTabArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsTabArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLNotification",
        "kind": "LinkedField",
        "name": "archiveNotification",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsTabArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLNotification",
        "kind": "LinkedField",
        "name": "archiveNotification",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c880e2e69856fa5f6f3864b7e2b92af4",
    "id": null,
    "metadata": {},
    "name": "NotificationsTabArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationsTabArchiveMutation(\n  $input: NodeInput!\n) {\n  archiveNotification(input: $input) {\n    isArchived\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9d327114b1bcb25ae89ba39cf452ec7c";

export default node;
